import React, { useState } from 'react';
import { TableColumn } from 'react-data-table-component';
import { useTranslation } from 'react-i18next';

import { SettingsButton } from 'src/components';
import { IPersonalContact } from 'src/interfaces';
import { ItemContainer, Container, HeaderLine, HeaderRightItems, TitleWrapper, TitleWrapperText } from './styles';
import { EmployeeContactsTable } from './components/employee-contacts-table';

const initialColumns = [
  {
    name: 'First Name',
    selector: (row: IPersonalContact) => row.firstName,
  },
  {
    name: 'Last Name',
    selector: (row: IPersonalContact) => row.lastName,
  },
  {
    name: 'Relationship Type',
    selector: (row: IPersonalContact) => row.relationship,
  },
  {
    name: 'Emergency',
    selector: (row: IPersonalContact) => (row.isEmergencyContact ? 'Yes' : 'No'),
  },
  {
    name: 'Home Phone',
    selector: (row: IPersonalContact) => {
      if (!row.homePhone) return '';
      const homePhone = String(row.homePhone);
      if (homePhone.length >= 4) {
        return `****${homePhone.slice(4)}`;
      }
      return homePhone;
    },
    width: '180px',
    sortField: 'birthDate',
    omit: false,
    sortable: true,
    reorder: true,
  },
  {
    name: 'Work Phone',
    selector: (row: IPersonalContact) => {
      if (!row.workPhone) return '';
      const workPhone = String(row.workPhone);
      if (workPhone.length >= 4) {
        return `****${workPhone.slice(4)}`;
      }
      return workPhone;
    },
    width: '180px',
    sortField: 'birthDate',
    omit: false,
    sortable: true,
    reorder: true,
  },
  {
    name: 'Email',
    selector: (row: IPersonalContact) => {
      if (!row.email) return '';
      const email = String(row.email);
      if (email.length >= 4) {
        return `*****${email.slice(4)}`;
      }
      return email;
    },
    width: '300px',
    sortField: 'primaryContactEmail',
    omit: false,
    sortable: true,
    reorder: true,
  },
];

const PersonalContactsTab: React.FC = () => {
  const { t } = useTranslation();
  const [columns, setColumns] = useState<TableColumn<any>[]>(initialColumns);

  return (
    <Container>
      <ItemContainer>
        <TitleWrapper>
          <TitleWrapperText>{t('employeePage.personalTab.contacts.title')}</TitleWrapperText>
          <HeaderLine />
          <HeaderRightItems>
            {/*
            <RegularButton>
              {t('employeePage.personalTab.contacts.addButton')}
            </RegularButton>
            */}
            <SettingsButton columns={columns} setColumns={setColumns} />
          </HeaderRightItems>
        </TitleWrapper>
        <EmployeeContactsTable columns={columns} />
      </ItemContainer>
    </Container>
  );
};

export default PersonalContactsTab;
